function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  flex-basis: 100%;\n  text-align: center;\n  padding: 10px;\n  display: block;\n  &.active {\n    color: ", ";\n  }\n  img {\n    width: 18px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  background-color: ", ";\n  position: fixed;\n  bottom: 0;\n  z-index: 10;\n  height: 4rem;\n  display: flex;\n  box-shadow: 0px -1px 8px rgba(0, 0, 0, 0.12);\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { defaultTheme } from '../../../utils';
import Text from '../../atoms/Text';
var AppNav = styled.div(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.background;
});
var AppTabContainer = styled.div(_templateObject2(), function (_ref2) {
  var theme = _ref2.theme;
  return theme.primaryColor;
});

var AppTab = function AppTab(_ref3) {
  var _tab$icons, _tab$icons2, _tab$icons3, _tab$icons4, _tab$label;

  var variant = _ref3.variant,
      tab = _ref3.tab,
      isSelected = _ref3.isSelected,
      tabClass = _ref3.tabClass,
      handleClick = _ref3.handleClick,
      rest = _objectWithoutPropertiesLoose(_ref3, ["variant", "tab", "isSelected", "tabClass", "handleClick"]);

  return /*#__PURE__*/React.createElement(AppTabContainer, _extends({
    className: variant + " " + tabClass + " " + (isSelected && 'active'),
    onClick: function onClick(event) {
      return handleClick(event, tab.key || '');
    }
  }, rest), !!(tab === null || tab === void 0 ? void 0 : (_tab$icons = tab.icons) === null || _tab$icons === void 0 ? void 0 : _tab$icons.active) && !!(tab === null || tab === void 0 ? void 0 : (_tab$icons2 = tab.icons) === null || _tab$icons2 === void 0 ? void 0 : _tab$icons2.inactive) && /*#__PURE__*/React.createElement("img", {
    src: isSelected ? tab === null || tab === void 0 ? void 0 : (_tab$icons3 = tab.icons) === null || _tab$icons3 === void 0 ? void 0 : _tab$icons3.active : tab === null || tab === void 0 ? void 0 : (_tab$icons4 = tab.icons) === null || _tab$icons4 === void 0 ? void 0 : _tab$icons4.inactive
  }), /*#__PURE__*/React.createElement(Text, {
    text: (_tab$label = tab === null || tab === void 0 ? void 0 : tab.label) !== null && _tab$label !== void 0 ? _tab$label : '',
    size: "iconLabel",
    variant: isSelected ? 'semiBold' : 'light',
    color: isSelected ? 'primary' : 'iconLabel'
  }));
};

var BottomNav = function BottomNav(_ref4) {
  var variant = _ref4.variant,
      tabs = _ref4.tabs,
      selectedTab = _ref4.selectedTab,
      containerClass = _ref4.containerClass,
      handleClick = _ref4.handleClick,
      rest = _objectWithoutPropertiesLoose(_ref4, ["variant", "tabs", "selectedTab", "containerClass", "handleClick"]);

  return /*#__PURE__*/React.createElement(AppNav, _extends({
    className: variant + " " + containerClass
  }, rest), tabs && tabs.map(function (item, index) {
    var _item$key;

    return /*#__PURE__*/React.createElement(AppTab, _extends({
      key: index,
      tab: item,
      isSelected: ((_item$key = item === null || item === void 0 ? void 0 : item.key) !== null && _item$key !== void 0 ? _item$key : '') === selectedTab,
      handleClick: handleClick
    }, rest));
  }));
};

BottomNav.propTypes = process.env.NODE_ENV !== "production" ? {
  variant: PropTypes.string,
  tabs: PropTypes.arrayOf(PropTypes.shape({
    icons: PropTypes.shape({
      active: PropTypes.string.isRequired,
      inactive: PropTypes.string.isRequired
    }),
    label: PropTypes.string,
    key: PropTypes.string.isRequired
  })),
  selectedTab: PropTypes.string,
  handleClick: PropTypes.func,
  containerClass: PropTypes.string,
  tabClass: PropTypes.string
} : {};
BottomNav.defaultProps = {
  variant: 'default',
  theme: defaultTheme,
  handleClick: function handleClick() {},
  selectedTab: '',
  containerClass: '',
  tabClass: ''
};
export default BottomNav;